export default __webpack_public_path__ + "static/award-2015-80d18fa7372b2d1b73b833b8c79af7f6.jpg";